import { Component, Input, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { IObjectivesFormState } from '../../../store/objective.state';
import { setObjectivePropertyAction } from '../../../store/objective.actions';
import { getObjectivePropertySelectors } from '../../../store/objective.selectors';
import { IGoalsResponse } from 'src/app/modules/interfaces/goals-dto.interface';
import { GoalsService } from 'src/app/services/goals.service';
import { getCookie } from 'src/app/utils/get-cookie';

@Component({
  selector: 'app-own-property',
  templateUrl: './own-property.component.html',
  styleUrls: ['./own-property.component.scss'],
})
export class OwnPropertyComponent implements OnInit {
  @Input() data: IGoalsResponse;
  selectedGoals: number[] = [];
  formsId: number = 0;
  check: number = 0;
  isLoading: boolean = false;
  buttonText: string = 'Salvar';

  panelOpenState = true;
  dataStoreProperty$: Observable<any>;
  dataStoreProperty: IObjectivesFormState;

  constructor(
    private store: Store,
    private readonly goalsService: GoalsService
  ) {
    this.formsId = Number(getCookie('formsId'));
  }

  ngOnInit(): void {
    this.loadSelectedGoals();
    this.getState();
    this.setValuesForm();
    this.saveState();
  }

  loadSelectedGoals() {
    this.goalsService.getSelectedGoals(this.formsId).subscribe((res: any) => {
      this.selectedGoals = res.data || [];
    });
  }

  getState(): void {
    this.dataStoreProperty$ = this.store.select(getObjectivePropertySelectors);
    this.dataStoreProperty$.subscribe((value) => {
      this.dataStoreProperty = {
        ...(this.dataStoreProperty = value),
      };
    });
  }

  UpdateGoals() {
    this.goalsService
      .createGoals(this.formsId, this.selectedGoals)
      .subscribe(() => {
        this.dataStoreProperty = {
          ...this.dataStoreProperty,
          isSelected: !this.dataStoreProperty.isSelected,
        };
        this.setState(this.dataStoreProperty);
        window.location.reload();
      });
  }

  unCheck(): void {
    const goalId = 3;
    this.selectedGoals = this.selectedGoals.filter((id) => id !== goalId);
    this.UpdateGoals();
  }

  saveForm(): void {
    const goalData = {
      check: this.check,
      motive: this.data.motive,
      target_date: this.data.target_date,
      investment_min: this.data.investment_min,
      investment_max: this.data.investment_max,
      observation: this.data.observation,
    };

    this.isLoading = true;
    this.buttonText = 'Salvando...';

    this.goalsService
      .updateGoals(this.formsId, this.data.id, goalData)
      .subscribe({
        next: () => {
          this.panelOpenState = false;
          this.saveState();
          this.isLoading = false;
          this.buttonText = 'Salvar';
        },
        error: (err) => {
          console.error('Erro ao salvar', err);
          this.isLoading = false;
          this.buttonText = 'Salvar';
        },
      });
  }

  saveState(): void {
    this.dataStoreProperty = {
      ...this.dataStoreProperty,
      isSelected: true,
      check: Boolean(this.check),
      description: this.data.motive,
      date: new Date(this.data.target_date),
      minimumInvestment: this.data.investment_min,
      maximumInvestment: this.data.investment_max,
      observation: this.data.observation,
    };
    this.setState(this.dataStoreProperty);
  }

  setState(data: IObjectivesFormState) {
    this.store.dispatch(setObjectivePropertyAction(data));
  }

  setValuesForm(): void {
    this.check =
      !!this.data.motive &&
      !!this.data.target_date &&
      !!this.data.investment_max
        ? 1
        : 0;

    this.data.check =
      !!this.data.motive &&
      !!this.data.target_date &&
      !!this.data.investment_max
        ? 1
        : 0;
    this.dataStoreProperty.check = this.check === 1 ? true : false;
    this.setState(this.dataStoreProperty);
  }

  updateInvestmentAmount(type: 'min' | 'max', event: any): void {
    if (type === 'min') {
      this.data.investment_min = event;
    } else {
      this.data.investment_max = event;
    }
    this.setValuesForm();
  }
}
